export default {
  model (resource) {
    return Object.assign({
      customerId: null,
      brand: '',
      model: '',
      year: null,
      type: '',
      machineryType: '',
      acquisitionDate: '',
      hpMotor: '',
      traction: '',
      serialNumber: '',
      supportType: '',
      saleType: null,
      supportPercent: null,
      secondhand: null,
      opportunityId: null,
      supportName: null
    }, resource)
  },
  rules () {
    return {
      brand: [
        {required: true, message: 'La marca es requerida'}
      ],
      model: [
        {required: true, message: 'El modelo es requerido'}
      ],
      year: [
        {required: true, message: 'El año es requerido'}
      ],
      type: [
        {required: true, message: 'El tipo es requerido'}
      ],
      acquisitionDate: [
        {required: true, message: 'La fecha de compra es requerido'}
      ],
      traction: [
        {required: true, message: 'El tipo de traccion es requerido'},
        {min: 1, max: 255, message: 'El tipo detraccion  debe ser entre 1 y 255 carácteres'}
      ],
      supportType: [
        {required: true, message: 'El tipo de apoyo es requerido'}
      ],
      supportPercent: [
        {type: 'number', message: 'El numero de bandas  debe ser numerico'}
      ]
    }
  },
  tractionCatalog: [
    {
      label: '2WD',
      value: '2WD'
    },
    {
      label: '4WD',
      value: '4WD'
    },
    {
      label: 'Ninguno',
      value: 'NONE'
    }
  ],
  supportCatalog: [
    {
      label: 'Estatal',
      value: 'STATE GOVERNMENT'
    },
    {
      label: 'Federal',
      value: 'FEDERAL GOVERNMENT'
    },
    {
      label: 'Privado',
      value: 'PRIVATE'
    },
    {
      label: 'Otro',
      value: 'OTHER'
    },
    {
      label: 'Ninguno',
      value: 'NONE'
    }
  ],
  powerRangeCatalog: [
    {
      value: '0-80.99',
      label: '0 a 80.99'
    },
    {
      value: '81-130.99',
      label: '81 a 130.99'
    },
    {
      value: '131>',
      label: 'Mayor a 131'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/models/machineries/machineries-model.js